import React, { useState, useEffect } from "react";
import ProfileImage from "../Assets/Dashboard/camera.png";

const ProfileHeader = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    photo: ProfileImage,
    name: "",
    role: "",
    bio: "",
    skills: [],
    notes: "",
  });
  const [newSkill, setNewSkill] = useState("");
  const [tempProfileData, setTempProfileData] = useState({});

  const saveProfileData = () => {
    setIsEditing(false);
    setTempProfileData(profileData); // Save the current data to temporary state
  };

  const cancelEdit = () => {
    setIsEditing(false);
    setProfileData(tempProfileData); // Revert to the saved state
  };

  const deleteField = (field) => {
    setProfileData((prev) => ({ ...prev, [field]: "" }));
  };

  const addSkill = () => {
    if (newSkill.trim()) {
      setProfileData((prev) => ({
        ...prev,
        skills: [...prev.skills, newSkill.trim()],
      }));
      setNewSkill("");
    }
  };

  const deleteSkill = (index) => {
    setProfileData((prev) => ({
      ...prev,
      skills: prev.skills.filter((_, i) => i !== index),
    }));
  };

  useEffect(() => {
    setTempProfileData(profileData); // Initialize temp data
  }, []);

  return (
    <div className="bg-white max-w-[400px] flex items-center flex-col rounded-3xl mt-11 ml-11 mr-10 p-10">
      <div>
        <img
          src={profileData.photo}
          alt="profile"
          className="rounded-full w-40 h-40 object-cover"
        />
        {isEditing && (
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setProfileData({
                ...profileData,
                photo: URL.createObjectURL(e.target.files[0]),
              })
            }
            className="mt-3"
          />
        )}
      </div>

      {isEditing ? (
        <>
          <input
            type="text"
            value={profileData.name}
            onChange={(e) => setProfileData({ ...profileData, name: e.target.value })}
            className="mt-5 font-bold text-blue-600 text-center border-2 rounded-xl w-full p-2"
          />
          <button
            onClick={() => deleteField("name")}
            className="mt-2 text-red-600 bg-red-100 px-3 py-1 rounded-full"
          >
            Delete Name
          </button>
        </>
      ) : (
        <h1 className="mt-5 font-bold text-blue-600">{profileData.name || "Name"}</h1>
      )}

      {isEditing ? (
        <>
          <input
            type="text"
            value={profileData.role}
            onChange={(e) => setProfileData({ ...profileData, role: e.target.value })}
            className="font-thin mb-5 text-center border-2 rounded-xl w-full p-2"
          />
          <button
            onClick={() => deleteField("role")}
            className="mt-2 text-red-600 bg-red-100 px-3 py-1 rounded-full"
          >
            Delete Role
          </button>
        </>
      ) : (
        <h2 className="font-thin mb-5">{profileData.role || "Role"}</h2>
      )}

      {isEditing ? (
        <>
          <textarea
            value={profileData.bio}
            onChange={(e) => setProfileData({ ...profileData, bio: e.target.value })}
            className="text-wrap font-extralight border-2 rounded-xl w-full p-2 h-20"
          />
          <button
            onClick={() => deleteField("bio")}
            className="mt-2 text-red-600 bg-red-100 px-3 py-1 rounded-full"
          >
            Delete Bio
          </button>
        </>
      ) : (
        <p className="text-wrap font-extralight">{profileData.bio || "Bio"}</p>
      )}

      <h1 className="mt-5 text-2xl font-bold self-start">Skills</h1>
      <div className="flex flex-wrap space-x-3 mt-2 mb-12">
        {profileData.skills.map((skill, index) => (
          <span
            key={index}
            className="flex items-center justify-center bg-gray-200 rounded-3xl p-2 w-auto border-2 border-gray-400 shadow-inner font-semibold text-blue-500"
          >
            {skill}
            {isEditing && (
              <button onClick={() => deleteSkill(index)} className="ml-2 text-red-600">
                ✕
              </button>
            )}
          </span>
        ))}
        {isEditing && (
          <div className="flex items-center mt-2">
            <input
              type="text"
              value={newSkill}
              onChange={(e) => setNewSkill(e.target.value)}
              placeholder="Add skill"
              className="border-2 rounded-xl p-2"
            />
            <button
              onClick={addSkill}
              className="ml-2 bg-blue-600 text-white px-3 py-1 rounded-xl"
            >
              Add
            </button>
          </div>
        )}
      </div>

      <h1 className="mt-5 text-2xl font-bold self-start">Notes</h1>
      {isEditing ? (
        <>
          <textarea
            value={profileData.notes}
            onChange={(e) => setProfileData({ ...profileData, notes: e.target.value })}
            className="border-2 px-2 pt-2 mt-2 w-80 h-32 rounded-xl"
          />
          <button
            onClick={() => deleteField("notes")}
            className="mt-2 text-red-600 bg-red-100 px-3 py-1 rounded-full"
          >
            Delete Notes
          </button>
        </>
      ) : (
        <p className="border-2 px-2 pt-2 mt-2 w-80 h-32 rounded-xl">
          {profileData.notes || "No notes added yet."}
        </p>
      )}

      <div className="flex space-x-4 mt-5">
        {isEditing ? (
          <>
            <button
              onClick={saveProfileData}
              className="bg-green-600 text-white font-bold px-6 py-2 rounded-xl"
            >
              Save
            </button>
            <button
              onClick={cancelEdit}
              className="bg-gray-600 text-white font-bold px-6 py-2 rounded-xl"
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            onClick={() => setIsEditing(true)}
            className="bg-blue-600 text-white font-bold px-10 py-3 rounded-xl"
          >
            Edit Profile
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileHeader;
